import useSlugExtractor from "@hooks/useSlugExtractor"

import { Table } from "@organisms"

import {
    getCategoryTabId,
    getCategoryTitle,
} from "@pages/Settings/SettingsCatalogs/SettingsCatalogsItemList/SettingsCatalogsItemList.utils"

import { CATALOG_ENDPOINTS } from "@endpoints/catalogs"

import { CatalogItemTableViewTabsProps } from "./CatalogItemTableView.types"

export const CatalogItemTableViewTabs = (props: CatalogItemTableViewTabsProps) => {
    const { catalogId, brandParam, categories } = props

    const [listEndpoint, countEndpoint] = useSlugExtractor([CATALOG_ENDPOINTS.ITEMS, CATALOG_ENDPOINTS.ITEMS_COUNT])

    // Catalog and brand scope every tab's listing; the brand param carries a real id or the
    // null-scope sentinel for the brandless page, and category tabs add their own filter on top.
    const scopeKwargs: [string, string][] = [
        ["catalog", String(catalogId)],
        ["brand", brandParam],
    ]

    return (
        <Table.Tabs>
            <Table.Tab
                id="all"
                title="All"
                phase="active"
                endpointKwargs={scopeKwargs}
                isDefaultActiveTabForPhase={true}
                listEndpoint={listEndpoint}
                countEndpoint={countEndpoint}
            />
            {categories.map((category) => (
                <Table.Tab
                    key={category.id}
                    id={getCategoryTabId(category)}
                    title={getCategoryTitle(category)}
                    phase="active"
                    endpointKwargs={[...scopeKwargs, ["category", String(category.id)]]}
                    isDefaultActiveTabForPhase={false}
                    listEndpoint={listEndpoint}
                    countEndpoint={countEndpoint}
                    // A catalog can expose dozens of category tabs; per-tab counts would fan out a
                    // count request per category on every keyword change.
                    hideCount={true}
                />
            ))}
        </Table.Tabs>
    )
}
